import { render, staticRenderFns } from "./addClrTest.vue?vue&type=template&id=30108cab&scoped=true&"
import script from "./addClrTest.vue?vue&type=script&lang=js&"
export * from "./addClrTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30108cab",
  null
  
)

export default component.exports